const templateUrl = require('./billing.html');

module.exports = {
  bindings: {
    paymentId: '<ogFor'
  },
  controller: require('./billing.controller'),
  templateUrl: templateUrl
};
